<h1 *ngIf="!loadingRoles && roles && roles.length > 0">Seleziona un ruolo con cui accedere</h1>
<h1 *ngIf="!loadingRoles && (!roles || roles.length === 0)" class="unauthorized">ACCESSO NEGATO - <span>Utente non autorizzato.</span></h1>
<app-breadcrumbs [breadLinks]="breadLinks"></app-breadcrumbs>
<div class="roles-container" *ngIf="!loadingRoles && roles && roles.length > 0">
    <mat-card class="role-card" *ngFor="let role of roles" (click)="toHome(role.id)">
        <mat-icon class="background-icon">person</mat-icon>
        <div class="icon-cropper">
            <div class="icon-container" [ngClass]="role.css"></div>
        </div>
        <mat-card-content>
            <div class="role-description">
                <span>
                    {{role.descrizione}}
                </span>
            </div>
        </mat-card-content>
    </mat-card>
</div>